import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import { type FragmentType } from "~/gql/runtime";
import { useNavLayout } from "~/features/app/landing-header/context";
import { Link } from "~/features/ui/link";
import { Logo } from "~/features/ui/logo";
import { Asset, type fragment as assetFragment } from "~/features/craft/asset";
type Props = {
  customLogo?: FragmentType<typeof assetFragment>;
};
const style = {
  transparent: {
    "borderColor": "rgba(255, 255, 255, 0.2)"
  },
  solid: {
    "borderColor": "rgb(0 7 4 / 0.1)",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 246 / var(--tw-bg-opacity))"
  },
  highlighted: {
    "borderColor": "rgb(0 7 4 / 0.1)",
    "backgroundColor": "var(--white-static)"
  }
} as const;
export function NavLogo(props: Props) {
  const {
    customLogo
  } = props;
  const {
    navTheme,
    isPageHighlighted
  } = useNavLayout();
  const surface = isPageHighlighted ? "highlighted" : navTheme;
  return <_StyledDiv $_css={[{
    "pointerEvents": "auto",
    "display": "flex",
    "height": "var(--header-height)",
    "alignItems": "center",
    "borderBottomWidth": "1px",
    "borderRightWidth": "1px",
    "paddingLeft": "1.6rem",
    "paddingRight": "1.6rem",
    "@media (min-width: 1024px)": {
      "paddingLeft": "4rem",
      "paddingRight": "4rem"
    }
  }, style[surface]]}>
      <Link href={process.env.NEXT_PUBLIC_URL} aria-label="Ouster">
        {customLogo ? <_StyledAsset asset={customLogo} imageProps={{
        sizes: "200px",
        width: 144,
        fit: "contain"
      }} /> : <_StyledLogo logo="full" variant={surface === "transparent" ? "light" : "dark"} />}
      </Link>
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-7agd3d-0"
})`${p => p.$_css}`;
var _StyledAsset = _styled2(Asset).withConfig({
  componentId: "sc-sf-7agd3d-1"
})({
  "width": "12rem",
  "@media (min-width: 1024px)": {
    "width": "14.4rem"
  }
});
var _StyledLogo = /*#__PURE__*/_styled3(Logo).withConfig({
  displayName: "nav-logo___StyledLogo",
  componentId: "sc-1hej0sn-0"
})({
  "width": "12rem",
  "@media (min-width: 1024px)": {
    "width": "14.4rem"
  }
});